import React, { memo } from 'react'
import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

import { useAuthContextExtended } from '@surglogs-app/auth'
import { SvgIcon } from '@surglogs-app/icons'
import { Box, Button, Input } from '@surglogs-app/ui'
import { WrapInToolTip } from '@surglogs-app/ui.tooltip'
import { emailValidator } from '@surglogs-app/util'

import { useTranslation } from '../services'

export interface PromoModalFormValues {
  email: string
}

interface PromoModalFormProps {
  onSubmit: (data: PromoModalFormValues) => void
  disabled?: boolean
  inline?: boolean
  submitLabel?: string
  submitIcon?: SvgIcon
}

export const PromoModalForm = memo(
  ({
    onSubmit,
    disabled = false,
    inline = false,
    submitLabel,
    submitIcon,
  }: PromoModalFormProps) => {
    const { data } = useAuthContextExtended()
    const { t } = useTranslation()
    const {
      handleSubmit,
      register,
      formState: { errors },
    } = useForm<PromoModalFormValues>({
      mode: 'onSubmit',
      reValidateMode: 'onChange',
      resolver: yupResolver(
        yup
          .object({
            email: emailValidator.required(),
          })
          .required(),
      ),
      defaultValues: { email: data?.user.email ?? '' },
    })

    return (
      <form
        {...{
          onSubmit: handleSubmit(onSubmit),
          style: { width: inline ? '100%' : 'auto' },
        }}>
        <Box {...{ gap: 'md', display: inline ? 'flex' : 'block' }}>
          <Input
            {...{
              ...register('email'),
              invalid: !!errors.email,
              placeholder: t('emailInputPlaceholder'),
              display: inline ? 'inline-block' : 'block',
              w: inline ? '60%' : '100%',
            }}
          />
          {disabled ? (
            <WrapInToolTip {...{ tooltipText: t('trialRequestDisabled') }}>
              <Button
                {...{
                  icon: submitIcon ?? undefined,
                  type: 'submit',
                  disabled,
                  variant: 'primary',
                  mt: inline ? 'abs.0' : 'sm',
                  w: inline ? '40%' : '100%',
                }}>
                {submitLabel ?? t('sendRequest')}
              </Button>
            </WrapInToolTip>
          ) : (
            <Button
              {...{
                icon: submitIcon ?? undefined,
                type: 'submit',
                disabled,
                variant: 'primary',
                mt: inline ? 'abs.0' : 'sm',
                w: inline ? '40%' : '100%',
              }}>
              {submitLabel ?? t('sendRequest')}
            </Button>
          )}
        </Box>
      </form>
    )
  },
)
